import { Routes } from '@angular/router';
import { AppShellComponent } from '@components/app-shell/app-shell.component';

export const routes: Routes = [
  {
    path: '',
    component: AppShellComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./domains/payments/payments.routes').then((m) => m.PAYMENT_ROUTES),
      },
      {
        path: 'admin',
        loadChildren: () => import('@portal/portal.routes').then((m) => m.PORTAL_ROUTES),
      },
      {
        path: '**',
        loadComponent: () => import('@shared/pages/not-found/not-found.component').then((m) => m.NotFoundComponent),
      },
    ],
  },
];
